export default __webpack_public_path__ + "assets/img/img-icon-requirement-alert.dfd1d6920814bba10a0f93f2ddef9059.svg";